import React, { ReactElement } from "react";
import { SpintrTypes } from "src/typings";
import { SocialBlogPost } from "../SocialBlogPost";
import { SocialFile } from "../SocialFile";
import { SocialGroup } from "../SocialGroup";
import { SocialImage } from "../SocialImage";
import { SocialImagePost } from "../SocialImagePost";
import { SocialNews } from "../SocialNews";
import { SocialPage } from "../SocialPage";
import { SocialPageUpdate } from "../SocialPageUpdate";
import { SocialPoll } from "../SocialPoll";
import { SocialWikiArticle } from "../SocialWikiArticle";
import "./SocialPostContentItem.scss";
import { SocialBookmark } from "../SocialBookmark";
import { ExternalFile } from "src/chat";
import { SocialProduct } from "../SocialProduct";
import SystemStatusFeedItem from "src/system-status/SystemStatusFeedItem";

const UberType = SpintrTypes.UberType;

interface IProps {
    post: Spintr.ISocialPostBase;
    parentPost: Spintr.ISocialPostBase;
    isShare?: boolean;
}

const getPostComponent = (post: Spintr.ISocialPostBase, parentPost: Spintr.ISocialPostBase, isShare?: boolean): ReactElement => {
    switch (post.Type) {
        case UberType.File:
            return <SocialFile post={post as Spintr.ISocialFile} />;
        case UberType.TextPage:
            return (
                <SocialPage
                    isShare={isShare}
                    post={post as Spintr.ISocialTextPage}
                />
            );
        case UberType.NewsArticle:
            return (
                <SocialNews
                    isShare={isShare}
                    post={post as Spintr.ISocialNewsArticle}
                />
            );
        case UberType.Image:
            return <SocialImage post={post as Spintr.ISocialImage} parentPost={parentPost} />;
        case UberType.ImagePost:
            return <SocialImagePost post={post as Spintr.ISocialImagePost} parentPost={parentPost} />;
        case UberType.WikiArticle:
            return <SocialWikiArticle post={post as Spintr.ISocialWikiArticle} />;
        case UberType.BlogPost:
            return <SocialBlogPost post={post as Spintr.ISocialBlogPost} />
        case UberType.Group:
            return <SocialGroup post={post as Spintr.ISocialGroup} />;
        case UberType.Poll:
            return <SocialPoll post={post as Spintr.ISocialPoll} />;
        case UberType.TextPageUpdate:
            return <SocialPageUpdate post={post as Spintr.ISocialPageUpdate} />;
        case UberType.Bookmark:
            return <SocialBookmark post={post as Spintr.ISocialStatusBookmark} />;
        case UberType.ExternalFile:
            if (!!post.externalFiles && post.externalFiles.length > 0) {
                return (
                    <div>
                        {post.externalFiles.map((file: any, index: number) => {
                            return (
                                <ExternalFile externalId={file.externalId} source={file.source} name={file.name} key={index} />
                            )
                        })}
                    </div>
                )
            }
            break;
        case UberType.SystemStatus:
            return <SystemStatusFeedItem post={post as Spintr.ISocialSystemStatus} parentPost={parentPost} />;
    }

    return null;
}

const SocialPostContentItem = (props: IProps) => {
    return (
        <div className="SocialPostContentItem">
            {getPostComponent(props.post, props.parentPost, props.isShare)}
        </div>
    )
}

export default SocialPostContentItem;
